import { render, staticRenderFns } from "./SpeakerList.vue?vue&type=template&id=8293faee"
import script from "./SpeakerList.vue?vue&type=script&lang=js"
export * from "./SpeakerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports